<script setup lang="ts">
import { Toaster } from 'pejer/src/components/ui/toast'
</script>
<template>
  <main class="flex min-h-dvh items-center justify-center w-full text-secondaryBlack">
    <!-- bg-slate-200/80 heropattern-wiggle-white  -->
    <RouterView v-slot="{ Component }" class="">
      <component :is="Component" />
    </RouterView>
  </main>
  <Toaster />
</template>
